import httpService from "./http.service";

class InsurancesService {
  getInsurancesUrl = "/insurances";

  getInsurances = () => {
    return httpService.get(this.getInsurancesUrl);
  };
  createInsurance = (model) => {
    return httpService.post("/insurances", model);
  };
  editInsurance = (id, model) => {
    return httpService.patch("/insurances/" + id, model);
  };
  deleteInsurance = (id) => {
    return httpService.delete("/insurances/" + id);
  };
}

const insurancesService = new InsurancesService();
export default insurancesService;
